import { Trans } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { boostersFontCss } from '@root/entities/premium/ui'
import { Drawer } from '@root/shared/ui-kit'

import { BuyBoosters } from '../../common/buy-boosters'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'
import type { DrawerProps } from '@root/shared/ui-kit'

type Props = Pick<DrawerProps, 'open' | 'onOpenChange'> & {
  currency: CurrencyModel
  premium: PremiumMetaModel | undefined
}

export const BuyBoostersDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  currency,
  premium,
}) => {
  return (
    <Root open={open} onOpenChange={onOpenChange}>
      <Body>
        <Title>
          <Trans
            i18nKey={'premium.pay.boosters.title'}
            components={[<TitleAccent key={0} />]}
          />
        </Title>
        <BuyBoosters
          currency={currency}
          premium={premium}
          onClose={() => {
            onOpenChange?.(false)
          }}
          device="mobile"
        />
      </Body>
    </Root>
  )
}

const Root = styled(Drawer)`
  background: var(--appearance-1);
  background-image: radial-gradient(
    55% 130px at 50% -5%,
    rgba(135, 135, 135, 0.2) 30%,
    transparent 100%
  );
`

const Body = styled.div`
  overflow: hidden;
  display: grid;

  padding: 10px 12px 32px;
`

const Title = styled(Typography).attrs({
  variant: 'body1-bold',
  component: 'h2',
})`
  color: var(--textA-12);
  text-align: center;
  margin-bottom: 32px;
`

const TitleAccent = styled(Typography).attrs({
  variant: 'h4',
  component: 'span',
})`
  ${boostersFontCss}
  font-size: 18px;
  line-height: 20px;
`
